import { Box, ImageListItemBar } from '@mui/material';
import { object } from 'prop-types';
import React, { Component } from 'react';
import ProgressiveImage from 'react-progressive-image';
import attachmentShape from 'shapes/attachment';
import connector from './connector';

class VideoTile extends Component {
  preview = () => {
    const { actions, video } = this.props;
    actions.videoModal.open(video.httpLink);
  };

  render() {
    const { video } = this.props;
    return (
      <ProgressiveImage src={video.meta.thumb} placeholder={video.meta.placeholder}>
        {(src, loading) => (
          <Box
            component="button"
            type="button"
            onClick={this.preview}
            sx={{
              width: '100%',
              height: '100%',
              background: 'transparent',
              border: 0,
              padding: 0,
              margin: 0,
              '& img': {
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                aspectRatio: '1/1',
              },
            }}
          >
            {/* eslint-disable-next-line jsx-a11y/alt-text */}
            <img
              src={src}
              style={
                loading
                  ? {
                      filter: 'blur(4px)',
                      transform: 'scale(1.05)',
                    }
                  : undefined
              }
            />
            <ImageListItemBar
              onClick={this.preview}
              sx={{
                height: 30,
                textAlign: 'right',
              }}
              slotProps={{
                subtitle: {
                  sx: {
                    display: 'flex',
                    alignItems: 'center',
                  },
                },
              }}
              subtitle={`▶ ${
                video.meta.duration?.match(/\d\d:\d\d/)
                  ? video.meta.duration.replace(/^00:0?(\d?\d:\d\d)$/, '$1')
                  : ''
              }`}
            />
          </Box>
        )}
      </ProgressiveImage>
    );
  }
}

VideoTile.propTypes = {
  video: attachmentShape.isRequired,
  actions: object.isRequired,
};

export default connector(VideoTile);
